export default __webpack_public_path__ + "static/media/x.91ee6684.svg";